const DATE_TIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;
export function seoulInput(value) {
  if (!value || !Number.isFinite(Date.parse(value))) return '';
  const parts = Object.fromEntries(new Intl.DateTimeFormat('sv-SE', { timeZone: 'Asia/Seoul', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date(value)).map(part => [part.type, part.value]));
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
}
export function instructionForm(document) {
  if (!document) return { body: '', status: 'paused', effective_from: '', effective_until: '', change_reason: '' };
  return { body: document.body, status: document.status, effective_from: seoulInput(document.effective_from), effective_until: seoulInput(document.effective_until), change_reason: '' };
}
export function validateInstruction(form, base) {
  const errors = {};
  if (!form.body.trim()) errors.body = '지침 원문을 입력하세요.';
  else if (new Blob([form.body]).size > 65536 || form.body.includes('\0')) errors.body = '원문은 64KiB 이하이며 NUL 문자를 포함할 수 없습니다.';
  if (!form.change_reason.trim()) errors.change_reason = '변경 이유를 입력하세요.';
  else if (new Blob([form.change_reason.trim()]).size > 1000) errors.change_reason = '변경 이유는 1,000바이트 이하로 입력하세요.';
  for (const field of ['effective_from', 'effective_until']) {
    const value = form[field];
    if ((!value && field === 'effective_from') || (value && (!DATE_TIME.test(value) || seoulInput(`${value}:00+09:00`) !== value))) errors[field] = '올바른 시작·종료 일시를 입력하세요.';
  }
  const payload = instructionPayload(form, base);
  if (!errors.effective_from && !errors.effective_until && payload.effective_until && Date.parse(payload.effective_until) <= Date.parse(payload.effective_from)) errors.effective_until = '종료는 시작보다 늦어야 합니다.';
  if (!['active', 'paused'].includes(form.status)) errors.status = '활성 또는 일시중지를 선택하세요.';
  return errors;
}
export function instructionPayload(form, base) {
  const time = field => form[field] === seoulInput(base?.[field]) ? base?.[field] ?? null : form[field] ? `${form[field]}:00+09:00` : null;
  return { markdown: form.body, status: form.status, timezone: 'Asia/Seoul', effective_from: time('effective_from'), effective_until: time('effective_until'), change_reason: form.change_reason.trim() };
}
